import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import Comment from "../models/comment.model";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { WhereList } from "../models/pagination";
import { environment } from "../../environments/environment";
import { NotificationService } from "./notifications.service";

@Injectable({
  providedIn: "root",
})
export class CommentService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Comment>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private notiService: NotificationService
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;

      this.collRef = this.db.collection(
        this.dbPath + `/${this.userLogin.shopId}/comments`
      );
    });
  }

  getNewComments(
    wheres: WhereList[],
    limit?: number,
    cursor?: any
  ): AngularFirestoreCollection<Comment> {
    return this.db.collection(this.dbPath, (ref) => {
      let query: CollectionReference | Query = ref;

      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);

      for (var i = 0; i < wheres.length; i++) {
        query = query.where(wheres[i].fieldPath, "==", wheres[i].value);
      }

      query = query.orderBy("updatedOn", "desc");

      query = limit ? query.limit(limit) : query.limit(10);
      if (cursor != null) query = query.startAfter(cursor);

      return query;
    });
  }

  getComments(wheres: WhereList[], limit?: number, cursor?: any): any {
    var db = firebase.default.firestore();

    var ref = db
      .collection(this.dbPath + `/${this.userLogin.shopId}/comments`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true);

    for (var i = 0; i < wheres.length; i++) {
      ref = ref.where(wheres[i].fieldPath, "==", wheres[i].value);
    }

    ref = ref.orderBy("updatedOn", "desc");

    ref = limit ? ref.limit(limit) : ref.limit(10);

    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  get(id: string) {
    // this.collRef = this.db.collection(this.dbPath + `/${shopId}/comments`);
    return this.collRef.doc(id).valueChanges();
  }

  create(comment: Comment): any {
    comment.level = comment.level ? comment.level : 0;
    comment.privacy = comment.privacy ? comment.privacy : false;
    comment.refAuthor = comment.refAuthor ? comment.refAuthor : null;

    comment.isApproved = false;
    comment.isActive = true;
    comment.isDeleted = false;
    comment.createdOn = new Date();
    comment.createdBy = this.userLogin.uid;
    comment.updatedOn = new Date();
    comment.updatedBy = this.userLogin.uid;
    comment.author = this.userLogin;
    comment.visibility = this.visibility;

    comment.noLiked = 0;
    comment.noReplied = 0;

    return this.collRef.add({ ...comment }).then((docRef) => {
      comment.id = docRef.id;

      if (comment.toUid != this.userLogin.uid) {
        this.notiService.create(
          "Bình luận",
          comment.mode,
          comment.refId,
          comment.id,
          comment.refTitle,
          comment.content,
          comment.toUid,
          comment.refUrl,
          ""
        );
      }

      return comment;
    });
  }

  update(comment: Comment): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.collRef.doc(comment.id).update({
      refTitle: comment.refTitle,
      content: comment.content,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      author: this.userLogin,
    });
  }

  delete(id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }
}
